<template>
  <ApolloQuery
    :query="require('./UserDataQuery.gql')"
    :variables="{ cityId: userData.cityId }"
    fetch-policy="network-only"
    @result="updateUserData"
    @error="userDataError"
  >
    <div v-if="!isLoading" slot-scope="{}">
      <alert v-if="!!alert.message" :alert="alert" />
      <app-drawer />
      <app-toolbar />
      <unsaved-changes-modal v-if="modal" @input="hideUnsavedChangesModal" @confirm="modal.callback">
        <span slot="header" v-t="modal.header" />
        <span slot="body" v-t="modal.body" />
      </unsaved-changes-modal>
      <welcome-modal v-if="showWelcomeModal" :display-name="displayName" />
      <v-content>
        <snackbar v-if="!!snackbar" :snackbar="snackbar" />
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-content>
    </div>
    <v-progress-circular
      v-else
      class="center-content"
      :style="{width: '100px', height: '100px'}"
      large
      :width="2.5"
      indeterminate
      color="primary"
    />
  </ApolloQuery>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { apolloClient } from '@/apollo';
import AuthenticationService from '@/services/AuthenticationService';
import StorageService from '@/services/StorageService';
import PushNotificationsService from '@/services/PushNotificationsService';
import UnsavedChangesModal from './unsaved-changes-modal/UnsavedChangesModal.vue';
import WelcomeModal from './welcome-modal/WelcomeModal.vue';
import AppDrawer from './drawer/AppDrawer.vue';
import AppToolbar from './toolbar/AppToolbar.vue';
import Alert from './notifications/alert.vue';
import Snackbar from './notifications/snackbar.vue';

export default {
  name: 'MainComponent',
  components: {
    'app-drawer': AppDrawer,
    'app-toolbar': AppToolbar,
    alert: Alert,
    snackbar: Snackbar,
    'unsaved-changes-modal': UnsavedChangesModal,
    'welcome-modal': WelcomeModal,
  },
  data: () => ({
    dialog: false,
    drawer: null,
    displayName: null,
    showWelcomeModal: false,
    isLoading: true,
  }),
  computed: {
    ...mapGetters('notificationsStore', ['alert', 'snackbar', 'modal']),
    ...mapGetters('userInfoStore', ['languages', 'userData']),
  },
  mounted() {
    PushNotificationsService.register();
  },
  methods: {
    ...mapActions('notificationsStore', ['hideUnsavedChangesModal']),
    ...mapActions('userInfoStore', ['loadUserData']),

    updateUserData({ data }) {
      if (!data) {
        apolloClient.queryManager.refetchQueryByName('CurrentUserQuery');
        return;
      }
      if (!data.currentUser.preferredLanguageId || !data.currentUser.cityId) {
        this.showWelcomeModal = true;
        this.displayName = data.currentUser.displayName;
        this.isLoading = false;
      } else {
        this.loadUserData({
          languageId: data.currentUser.preferredLanguageId,
          cityId: data.currentUser.cityId,
          displayName: data.currentUser.displayName,
          balance: data.currentUser.balance,
          balanceThreshold: data.currentUser.balanceThreshold,
        });
        this.$i18n.locale = this.languages.find(l => l.id === data.currentUser.preferredLanguageId).locale;
        this.isLoading = false;
      }
    },
    userDataError() {
      if (!StorageService.get('loggedUser')) {
        AuthenticationService.silentLogin();
      }
      this.$nextTick(() => {
        apolloClient.queryManager.refetchQueryByName('CurrentUserQuery');
      });
    },
  },
};
</script>

<style scoped>
.center-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
